__turbopack_context__.v({
  "dropdowns": "styles-module__C_uNEa__dropdowns",
});
